import api from "../Config/api";

export default async function getMetadata () {
  const response = (await api.get("/api/metadata")).data
  console.log("Metadata API Success ===>", response);
  return response;
}